// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import FeaturesRankDiamond from '../_raw/features/icon_features_rank_diamond.svg';
import withIconProps from '../withIconProps';

export default withIconProps(FeaturesRankDiamond, { shouldSetDefaultSize: false });
